export default "__VITE_ASSET__BQGK0ONj__"